import { Stack } from "@mui/material";
import { ReactNode } from "react";
import { componentMapper } from "../../../constant";

export const ListWrapper = ({
  title,
  children,
  icon,
  gap = "12px",
}: {
  children: ReactNode;
  title: string;
  icon?: string;
  gap?: string;
}) => {
  return (
    <Stack gap={gap}>
      {componentMapper.h4(title, icon)}
      {children}
    </Stack>
  );
};
